import * as userConstants from "@/core/models/usersAndPermissions";
import { routes } from "@/routing/routes";

const router = [
  {
    path: routes.paymentModes.path,
    name: routes.paymentModes.name,
    component: () =>
      import(/* webpackChunkName: "db-payments" */ "@/view/pages/Configuration/PaymentModes/PaymentModes.vue"),
    props: (route: any) => ({
      alert: route.query.alert ? JSON.parse(route.query.alert) : null,
    }),
    meta: {
      permission: userConstants.ROLE_PAYMENT_MODES_PAGE,
    },
  },
  {
    path: routes.editPaymentMode.path,
    name: routes.editPaymentMode.name,
    component: () =>
      import(/* webpackChunkName: "db-payments" */ "@/view/pages/Configuration/PaymentModes/PaymentMode.vue"),
    meta: {
      permission: userConstants.ROLE_PAYMENT_MODE_UPDATE_PAGE,
    },
  },
];

export default router;
